import React, { useState } from 'react';
import { Dropdown } from 'antd';
import { ClockIcon } from '@/assets/icons/icons';
import EllipsisTooltip from '@/components/EllipsisTooltip';
import { TimezoneMode } from '../../types';
import { getUserTimeZone } from '@/common/interceptor/interceptor';

interface DateTimeMenuProps {
  mode: TimezoneMode;
  onChange: (mode: TimezoneMode) => void;
  /** Only present when the feed is filtered to exactly one user. */
  subjectLabel?: string;
}

const DateTimeMenu: React.FC<DateTimeMenuProps> = ({
  mode,
  onChange,
  subjectLabel,
}) => {
  const [open, setOpen] = useState(false);

  const select = (next: TimezoneMode) => {
    onChange(next);
    setOpen(false);
  };

  const dateTimeOptions: Array<{
    value: TimezoneMode;
    label: string;
  }> = [
    {
      value: 'browser',
      label: `My time zone (${getUserTimeZone().replace(/_/g, ' ')})`,
    },
    ...(subjectLabel
      ? [
          {
            value: 'subject' as TimezoneMode,
            label: subjectLabel,
          },
        ]
      : []),
  ];

  const overlay = (
    <div
      className='activity-feed-dropdown-card activity-datetime-menu'
      onClick={(e) => e.stopPropagation()}
    >
      <div className='activity-feed-dropdown-header'>Date / time</div>

      {dateTimeOptions.map(({ value, label }) => (
        <div
          key={value}
          className={`activity-feed-dropdown-item activity-feed-datetime-item ${
            mode === value ? 'is-selected' : ''
          }`}
          onClick={() => select(value)}
        >
          <EllipsisTooltip
            text={label}
            className='activity-feed-datetime-label'
          />
        </div>
      ))}
    </div>
  );

  return (
    <Dropdown
      dropdownRender={() => overlay}
      trigger={['click']}
      open={open}
      onOpenChange={setOpen}
      placement='bottomRight'
      overlayClassName='activity-feed-dropdown-overlay'
    >
      <span
        className='activity-feed-header-icon-btn'
        title='Timezone'
        aria-label='Date / time'
      >
        <ClockIcon width={14} height={14} color='var(--text-secondary)' />
      </span>
    </Dropdown>
  );
};

export default DateTimeMenu;
